import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import { media } from 'src/styles/styled-components'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'

const gapHorizontal = {
  mobile: '25px',
  tablet: '45px',
  desktop: '8%',
}

const gapVertical = {
  mobile: '30px',
  tablet: '70px',
  desktop: '85px',
}

const StyledWrapper = styled.div`
  background-color: ${ ({ theme }) => theme.colors.black };
  color: ${ ({ theme }) => theme.colors.white };
  padding-bottom: 40px;
  padding-top: 40px;

  ${ media.tablet`
    padding-top: 80px;
    padding-bottom: 80px;
  ` }

  ${ media.desktop`
    padding-top: 100px;
    padding-bottom: 100px;
  ` }
`

const StyledContainer = styled(ArBaseContainer)`
  margin-bottom: ${ '-' + gapVertical.mobile };

  ${ media.tablet`
    margin-bottom: ${ '-' + gapVertical.tablet };
  ` }

  ${ media.desktop`
    margin-bottom: ${ '-' + gapVertical.desktop };
  ` }
`

const StyledTitle = styled.h2`
  font-size: 2.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  line-height: 1.18;
  margin-bottom: 20px;
  text-align: center;

  ${ media.tablet`
    font-size: 3.8rem;
    margin-bottom: 25px;
  ` }

  ${ media.desktop`
    margin-bottom: 20px;
    line-height: 1.2;
    font-size: 4.5rem;
  ` }
`

const StyledDescription = styled.p`
  font-size: 1.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  letter-spacing: 0.01em;
  line-height: 1.55;
  text-align: center;

  ${ media.tablet`
    max-width: 333px;
    margin-left: auto;
    margin-right: auto;
  ` }

  ${ media.desktop`
    max-width: none;
    line-height: 1.6;
    /* font-size: 1.8rem; */
  ` }
`

const StyledList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-left: ${ '-' + gapHorizontal.mobile };
  margin-top: 30px;

  ${ media.tablet`
    margin-left: ${ '-' + gapHorizontal.tablet };
    margin-top: 90px;
    ${ ({ twoTabletColumns }) => twoTabletColumns && css`
      justify-content: space-around;
      margin-left: 0;
    ` }
  ` }

  ${ media.desktop`
    margin-top: 85px;
    margin-left: ${ '-' + gapHorizontal.desktop };
  ` }
`

const StyledItem = styled.li`
  display: ${ p => p.scHideOnMobile && 'none' };
  margin-bottom: ${ gapVertical.mobile };
  margin-left: ${ gapHorizontal.mobile };
  text-align: center;
  width: calc(50% - ${ gapHorizontal.mobile });

  ${ media.tablet`
    display: block;
    margin-left: ${ gapHorizontal.tablet };
    margin-bottom: ${ gapVertical.tablet };
    width: calc(33.33% - ${ gapHorizontal.tablet });
    ${ ({ twoTabletColumns }) => twoTabletColumns && css`
      margin-left: 0;
      width: calc(40% - ${ gapHorizontal.tablet });
    ` }
  ` }

  ${ media.desktop`
    width: calc(33.33% - ${ gapHorizontal.desktop });
    margin-left: ${ gapHorizontal.desktop };
    margin-bottom: ${ gapVertical.desktop };
  ` }
`

const StyledItemImage = styled(ArBaseImage)`
  display: inline-block;
  width: 100px;
  margin-bottom: 20px;

  ${ media.tablet`
    width: 120px;
    margin-bottom: 30px;
  ` }

  ${ media.desktop`
    margin-bottom: 55px;
  ` }
`

const StyledItemTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Bold };
  letter-spacing: 0.01em;
  line-height: 1.55;
  margin-bottom: 10px;
  text-align: center;

  ${ media.desktop`
    font-size: 2.8rem;
    line-height: 1.6;
    font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  ` }
`

const StyledItemDescription = styled.p`
  font-size: 1.4rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  letter-spacing: 0.01em;
  line-height: 1.57;
  text-align: center;

  ${ media.tablet`
    font-size: 1.8rem;
  ` }
`

class Ar3ColFeatures extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    features: PropTypes.array,
  }

  render () {
    const { title, description, features, twoTabletColumns } = this.props

    return (
      <StyledWrapper>
        <StyledContainer>
          <StyledTitle>{ title }</StyledTitle>
          <StyledDescription>{ description }</StyledDescription>
          <StyledList twoTabletColumns={twoTabletColumns}>
            {features.map(({ image, title, description, scHideOnMobile }, index) =>
              <StyledItem key={index} scHideOnMobile={scHideOnMobile} twoTabletColumns={twoTabletColumns}>
                <StyledItemImage
                  src={image.url}
                  srcset={image.url2 ? `${ image.url2 } 2x` : null}
                  alt={image.alt}
                  scAspectRatio={1}
                ></StyledItemImage>
                <StyledItemTitle>{ title }</StyledItemTitle>
                <StyledItemDescription>{ description }</StyledItemDescription>
              </StyledItem>
            )}
          </StyledList>
        </StyledContainer>
      </StyledWrapper>
    )
  }
}

export default Ar3ColFeatures
